"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicPrivacyNoticeArrowListItems = void 0;
const react_1 = __importDefault(require("react"));
const lib_1 = require("@brandfree-front/lib");
const PublicPrivacyNoticeInfoModal_1 = __importDefault(require("./PublicPrivacyNoticeInfoModal"));
const PublicPrivacyNoticeArrowListItems = (props) => {
    const { categories } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, categories.map((category, index) => (react_1.default.createElement(lib_1.ModalProvider, { key: index },
        react_1.default.createElement(lib_1.ModalTrigger, null,
            react_1.default.createElement(lib_1.ArrowListItem, { url: "#" }, category.heading)),
        react_1.default.createElement(PublicPrivacyNoticeInfoModal_1.default, { type: category.modalType, heading: category.heading }))))));
};
exports.PublicPrivacyNoticeArrowListItems = PublicPrivacyNoticeArrowListItems;
